import gql from "graphql-tag";

export default gql`
  mutation createOrderRating(
    $orderId: ID!
    $partnerId: ID!
    $rating: Float!
    $comments: String
  ) {
    createOrderRating(
      orderId: $orderId
      partnerId: $partnerId
      rating: $rating
      comments: $comments
    ) {
      partnerId
      orderId
      consumerId
      rating
      comments
      createdAt
      updatedAt
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutation/CreateOrderRating.js